module.exports = __webpack_public_path__ + "./img/LogoMobile.d6009fe76ffa08f5d4f838c86cf7f79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/LogoMobile.png
// module id = ./src/assets/img/brand/LogoMobile.png
// module chunks = 11